import * as React from 'react';
import { colors } from '../../../index';

const IconTransfer = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 16 10",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.308 8.333V6.111H3.385V4.445L.5 7.222 3.385 10V8.333h6.923zM15.5 2.778L12.615 0v1.667H5.692v2.222h6.923v1.667L15.5 2.778z",
    fill: "currentColor"
  }));
};

export default IconTransfer;